import { FloatingPanel } from "antd-mobile";

export default FloatingPanel;
